import styled from 'styled-components'

export default styled.div`
  color: #8497A2;
`



// WEBPACK FOOTER //
// ./src/components/WidgetPicker/WidgetPickerRow/Description.js